<template>
	<BaseModalWrap
		@close="modal.close()"
		v-model:show="modal.show"
		:blur="modal.blur"
	>
		<Component
			:is="modal.currentComponent"
			v-bind="modal.currentComponentProps"
		/>
	</BaseModalWrap>
</template>
<script setup lang="ts">
import { useModalStore } from '../../stores/modal'
import BaseModalWrap from './BaseModalWrap.vue'

const modal = useModalStore()
</script>
